<template>
  <div class="d-grouping text-dark">
    <div class="d-grouping__header">
      <h1>{{ $t('vue2.tagging.tagging_users') }}</h1>
      <div class="d-grid-table">
        <div class="d-grid-table__column d-grid-table__column-1">
          <div class="d-grid-table__column-header">
            {{ i18n['groups'] }}
          </div>
          <ul>
            <li class="tags-li__create">
              <button class="btn btn-trans" @click="setIsModal(true)">
                + {{ i18n['create_a_new_group'] }}
              </button>
            </li>
            <li :class="{'filter--active': !activeTag}" @click="setActiveTag(null)">
              <div>{{ i18n['all'] }}</div>
              <div>
                <span class="icon-user"></span>
                {{ usersSortedOnName.length }}
              </div>
            </li>
            <li
              class="tag-filter"
              v-for="tag in tagsWithProps"
              :key="tag.v_name"
              :class="[{'filter--active': activeTag === tag.v_name}]"
              @click="setActiveTag(tag.v_name)"
              ref="droppable_elements"
              @dragover.prevent
              @dragenter.prevent="dragEnter(tag, $event)"
              @dragleave.prevent="dragLeave"
              @drop.prevent="drop(tag, $event)">
              <div class="tags-li__left">
                <DDropdown>
                  <ul slot="list">
                    <li @click="setTheEditTag(tag)"><span class="icon-pencil"></span> {{ $t('vue2.common.rename') }}
                    </li>
                    <li class="d-item-warning" @click="setTheDeleteTag(tag)">
                      <span class="icon-bin"></span>
                      {{ $t('vue2.common.delete') }}
                    </li>
                  </ul>
                </DDropdown>
                <p>{{ tag.v_name }}</p>
              </div>
              <div>
                <span class="icon-user"></span>
                {{ tag.v_number_of_persons }}
              </div>
            </li>
          </ul>
        </div>
        <div class="d-grid-table__column d-grid-table__column-3">
          <div class="d-grid-table__column-header">
            <div class="d-grid-table__column-header__left">
              {{ $t('vue2.common.users') }}
              <template v-if="activeTag"> {{ i18n['in_the_group'] }}: <span
                class="icon-price-tag2 marg-5-right marg-1-left"></span>{{ activeTag }}
              </template>
            </div>
            <div class="d-grid-table__column-header__right">
              <div><Loader v-if="isLoading" :isSmall="true" bg-color="#f6f9fc"></Loader></div>
              <DSelect
                class="marg-1-left"
                v-if="activeTag"
                :items="usersForDSelect"
                @add="addUserToTag($event)"
                :itemsSelected="[]"
                :placeholder="$t('vue2.common.add_user')"
                :showSelectedUsers="false">
              </DSelect>
            </div>
          </div>
          <ul>
            <li class="users-list-header">
              <span class="text-link" @click="toggleAll">
                <template v-if="usersSelectedForDrag.length < 1">{{ $t('vue2.tagging.select_all') }}</template>
                <template v-else>{{ $t('vue2.tagging.unselect_all') }}</template>
              </span>
            </li>
            <li
              class="user-in-list"
              v-for="user in filteredUsers"
              :key="user.id"
              :class="{'isSelected': user.v_isSelectedForDrag}"
              draggable="true"
              @dragover.stop
              @dragstart.stop="dragStart(user, $event)"
              @dragend.stop="dragEnd(user, $event)"
              @drop.prevent="drop(user, $event)">
              <div class="user-in-list__left"
                   :content="i18n['drag_and_drop_explained']"
                   v-tippy="{boundary: 'window', arrow: false, placement : 'left-start'}">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                     id="Capa_1" x="0px" y="0px" width="13px" height="13px" viewBox="0 0 572.156 572.156"
                     style="enable-background:new 0 0 572.156 572.156;" xml:space="preserve">
                <g>
                  <polygon
                    points="495.405,241.769 418.657,197.457 418.657,258.115 314.042,258.115 314.042,153.498 374.699,153.498    330.389,76.751 286.078,0 241.769,76.751 197.457,153.498 258.115,153.498 258.115,258.115 153.498,258.115 153.498,197.457    76.751,241.767 0,286.078 76.751,330.387 153.498,374.699 153.498,314.042 258.115,314.042 258.115,418.657 197.457,418.657    241.767,495.405 286.078,572.156 330.387,495.405 374.699,418.657 314.042,418.657 314.042,314.042 418.657,314.042    418.657,374.699 495.405,330.389 572.156,286.078  "/>
                </g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
              </svg>
                <div class="icon__bg-circle" @click="setUsersSelectedForDrag(user)">
                  <div class="d-checkbox" :class="{'d-checkbox--active': false}"></div>
                </div>
                <div class="user-name">{{ user.name }}</div>
              </div>
              <div class="user-tags">
                <div v-for="tag in user.user_tags" class="d-tag">
                  <div class="d-tag__text">{{ tag }}</div>
                  <div class="icon-cross2 d-tag__icon" @click="deleteTagFromUser(user, tag)"></div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <DModal v-if="isModal" :showClose="false" :is-bg-overlay="true">
      <div slot="insertComponent">
        <div class="d-modal__header">
          <h2>
            <span v-if="!theEditTag && !theDeleteTag">{{ i18n['create_group'] }}</span>
            <span v-if="theEditTag && !theDeleteTag">{{ i18n['edit_group'] }}</span>
            <span v-if="theDeleteTag">{{ i18n['delete_group'] }}</span>
          </h2>
          <div class="role-modal__close icon__bg-circle" @click="setIsModal(false)">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="d-modal__body">
          <div class="d-input-group marg-1-bottom" v-if="!theDeleteTag">
            <label class="d-label marg-5-bottom">{{ i18n['name_for_group'] }}</label>
            <input type="text" v-model.lazy="tagTitle" v-focus>
          </div>
          <div class="d-input-group marg-2-bottom" v-if="!theDeleteTag && !theEditTag">
            <label class="d-label marg-5-bottom">{{ i18n['select_a_user'] }}</label>
            <DSelectUsers @update="setSelectedUsers"></DSelectUsers>
          </div>
          <div class="d-modal__buttons">
            <button class="marg-10-right" @click="setIsModal(false)">{{ $t('vue2.common.cancel') }}</button>
            <button class="submit-button"
                    :class="[
                    {'submit-button--disabled': tagTitle.length < 1 || selectedUserIds.length === 0},
                    {'submit-button--loading': isButtonLoading}
                    ]"
                    v-if="!theEditTag && !theDeleteTag"
                    @click="createTag">
              {{ $t('vue2.common.create') }}
            </button>
            <button class="submit-button"
                    v-if="theEditTag"
                    :class="[
                    {'submit-button--disabled': tagTitle.length < 1},
                    {'submit-button--loading': isButtonLoading}
                    ]"
                    @click="editTag">
              {{ $t('vue2.common.save') }}
            </button>
            <button class="submit-button submit-button--danger" :class="{'submit-button--loading': isButtonLoading}"
                    v-if="theDeleteTag" @click="deleteTag">
              {{ $t('vue2.common.delete') }}
            </button>
          </div>
        </div>
      </div>
    </DModal>
    <div ref="customdrag" class="d-custom-drag" style="display: none">
      <span class="icon-user"></span> {{ i18n['add'] }} {{ usersSelectedForDrag.length }}
      <template v-if="usersSelectedForDrag.length === 1"> {{ $t('vue2.common.user') }}</template>
      <template v-else> {{ $t('vue2.common.users') }}</template>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import docendo from '../../docendo'
import DDropdown from '../common/DDropdown'
import DModal from '../common/DModal'
import eventbus from '../../eventbus'
import DSelect from '../DSelect/DSelect'
import DSelectUsers from '../DSelect/DSelectUsers'
import Loader from '../common/Loader'

const userLocale = window.USER && window.USER.language ? window.USER.language : 'da'

const I18N = {
  da: {
    groups: 'Grupper',
    create_a_new_group: 'Opret ny gruppe',
    all: 'Alle',
    in_the_group: 'i gruppen',
    create_group: 'Opret gruppe',
    edit_group: 'Redigér gruppe',
    delete_group: 'Slet gruppe',
    name_for_group: 'Navn på gruppen',
    select_a_user: 'Vælg mindst én bruger (tilføj flere senere)',
    created: 'Oprettet',
    updated: 'Opdateret',
    deleted: 'Slettet',
    add: 'Tilføj',
    drag_and_drop_explained: 'Drag and drop bruger til gruppe'
  },
  nb: {
    groups: 'Grupper',
    create_a_new_group: 'Opprett ny gruppe',
    all: 'Alle',
    in_the_group: 'i gruppen',
    create_group: 'Opprett gruppe',
    edit_group: 'Rediger gruppe',
    delete_group: 'Slett gruppe',
    name_for_group: 'Navn på gruppe',
    select_a_user: 'Velg minst en bruker',
    created: 'Opprettet',
    updated: 'Oppdatert',
    deleted: 'Slettet',
    add: 'Legg til',
    drag_and_drop_explained: 'Dra og slipp bruker til gruppe'
  },
  en: {
    groups: 'Groups',
    create_a_new_group: 'Create new group',
    all: 'All',
    in_the_group: 'in the group',
    create_group: 'Create group',
    edit_group: 'Edit group',
    delete_group: 'Delete group',
    name_for_group: 'Name for group',
    select_a_user: 'Select minimum one user',
    created: 'Created',
    updated: 'Updated',
    deleted: 'Deleted',
    add: 'Add',
    drag_and_drop_explained: 'Drag and drop user to group'
  }
}

export default {
  components: {Loader, DSelectUsers, DModal, DDropdown, DSelect},
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus()
      }
    }
  },
  data () {
    return {
      tags: [],
      activeTag: null,
      isModal: false,
      theEditTag: null,
      theDeleteTag: null,
      tagTitle: '',
      selectedUserIds: [],
      isButtonLoading: false,
      dragItem: null,
      dragEvt: null,
      usersSelectedForDrag: [],
      isShowDragExplainer: false,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'usersSortedOnName',
      'allUsersInHash'
    ]),
    schoolId () {
      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id
    },
    locale () {
      return window.USER && window.USER.language ? window.USER.language : 'en'
    },
    i18n () {
      return I18N[this.locale]
    },
    sortedTags () {
      return this.tags.sort((a, b) => a.localeCompare(b, userLocale, {
        numeric: true,
        sensitivity: 'base'
      }))
    },
    tagsWithProps () {
      return this.sortedTags.map(tag => {
        let tagObj = {
          v_name: tag,
          v_number_of_persons: this.getUsersWithTag(tag).length
        }
        return tagObj
      })
    },
    usersWithProps () {
      return this.usersSortedOnName.map(user => {
        const iSSelectedForDrag = this.usersSelectedForDrag.indexOf(user.id) > -1
        this.$set(user, 'v_isSelectedForDrag', iSSelectedForDrag)
        return user
      })
    },
    filteredUsers () {
      return this.getUsersWithTag(this.activeTag)
    },
    filteredUserIds () {
      return this.filteredUsers.map(user => user.id)
    },
    usersForDSelect () {
      return this.usersSortedOnName.filter(user => this.filteredUserIds.indexOf(user.id) < 0)
    }
  },
  methods: {
    setActiveTag (tag) {
      this.activeTag = tag
      this.usersSelectedForDrag = []
    },
    setUsersSelectedForDrag (user) {
      const idx = this.usersSelectedForDrag.indexOf(user.id)
      if (idx < 0) {
        this.usersSelectedForDrag.push(user.id)
      } else {
        this.usersSelectedForDrag.splice(idx, 1)
      }
    },
    setSelectedUsers (users) {
      this.selectedUserIds = users.map(user => user.id)
    },
    setIsModal (boolean) {
      this.isModal = boolean
      if (!boolean) {
        this.theDeleteTag = null
        this.theEditTag = null
        this.tagTitle = ''
        this.selectedUserIds = []
      }
    },
    isSubmitted (tagTitle) {
      this.isButtonLoading = false
      this.getTags()
      this.reset()
      this.setIsModal(false)
      this.$store.dispatch('getUsers')
      if (tagTitle) {
        this.activeTag = tagTitle
      }
    },
    reset () {
      this.activeTag = null
      this.theDeleteTag = null
      this.theEditTag = null
      this.tagTitle = ''
    },
    setTheDeleteTag (tag) {
      this.theDeleteTag = tag
      this.setIsModal(true)
    },
    setTheEditTag (tag) {
      this.theEditTag = tag
      this.tagTitle = tag.v_name
      this.setIsModal(true)
    },
    getTags () {
      docendo.schoolTags(this.schoolId, data => {
        this.tags = data
      })
    },
    getUsersWithTag (tag) {
      if (!tag) {
        return this.usersSortedOnName
      }
      return this.usersWithProps.filter(user => user.user_tags.indexOf(tag) > -1)
    },
    toggleAll () {
      if (this.usersSelectedForDrag.length > 0) {
        this.usersSelectedForDrag = []
      } else {
        this.usersSelectedForDrag = []
        this.filteredUserIds.forEach(userId => {
          this.usersSelectedForDrag.push(userId)
        })
      }
    },
    createTag () {
      const successText = this.i18n['created']
      if (this.tagTitle.length < 1 || this.selectedUserIds.length === 0) {
        return
      }
      this.isButtonLoading = true
      docendo.schoolTagsBulkCreate(this.schoolId, [this.tagTitle], this.selectedUserIds, success => {
        this.isSubmitted()
        eventbus.toast = {text: successText, 'success': true}
      }, failure => {
        this.isButtonLoading = false
        eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
      })
    },
    deleteTag () {
      const successText = this.i18n['deleted']
      this.isButtonLoading = true
      docendo.schoolTagsBulkDelete(this.schoolId, [this.theDeleteTag.v_name], this.filteredUserIds, success => {
        this.isSubmitted()
        eventbus.toast = {text: successText, 'success': true}
      }, failure => {
        this.isSubmitted()
        eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
      })
    },
    editTag () {
      if (this.tagTitle.length < 1) {
        return
      }
      const successText = this.i18n['updated']
      this.isButtonLoading = true
      docendo.schoolTagsBulkDelete(this.schoolId, [this.theEditTag.v_name], this.filteredUserIds, success => {
        docendo.schoolTagsBulkCreate(this.schoolId, [this.tagTitle], this.filteredUserIds, success => {
          this.isSubmitted(this.tagTitle)
          eventbus.toast = {text: successText, 'success': true}
        }, failure => {
          this.isButtonLoading = false
          eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
        })
      }, failure => {
        this.isSubmitted()
        eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
      })
    },
    dragStart (item, evt) {
      this.isShowDragExplainer = false
      this.dragItem = item
      const idx = this.usersSelectedForDrag.indexOf(item.id)
      if (idx < 0) {
        this.usersSelectedForDrag.push(item.id)
      }
      this.dragEvt = evt
      this.dragEvt.target.classList.add('isDragging')
      const el = this.$refs.customdrag
      el.style.display = 'flex'
      evt.dataTransfer.setDragImage(el, 0, 0)
    },
    dragEnd () {
      if (!this.dragItem) {
        return
      }
      this.$refs.customdrag.style.display = 'none'
      this.dragEvt.target.classList.remove('isDragging')
      this.dragEvt.target.style.display = ''
      this.usersSelectedForDrag = []
      this.dragItem = null
      this.dragEvt = null
    },
    dragEnter (tag, evt) {
      if (!this.dragItem) {
        return
      }
      evt.target.classList.add('isDragEnter')
    },
    dragLeave (evt) {
      if (!this.dragItem) {
        return
      }
      evt.target.classList.remove('isDragEnter')
    },
    drop (tag) {
      if (!this.dragItem) {
        return
      }
      this.addTagToItems(tag)
      this.dragEnd()
      let elements = this.$refs.droppable_elements
      for (let i = 0; i < elements.length; i++) {
        elements[i].classList.remove('isDragEnter')
      }
    },
    addTagToItems (tag) {
      this.isLoading = true
      const successText = this.i18n['updated']
      // Dont add them if they already have the tag
      const users = this.usersSelectedForDrag.map(userId => this.allUsersInHash[userId])
      const userIdsToAdd = users.filter(user => user.user_tags.indexOf(tag.v_name) < 0).map(user => user.id)
      docendo.schoolTagsBulkCreate(this.schoolId, [tag.v_name], userIdsToAdd, success => {
        eventbus.toast = {text: successText, 'success': true}
        this.isSubmitted(this.activeTag)
        this.isLoading = false
      }, failure => {
        eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
      })
    },
    deleteTagFromUser (user, tag) {
      this.isLoading = true
      docendo.schoolTagsBulkDelete(this.schoolId, [tag], [user.id], success => {
        this.isSubmitted(this.activeTag)
        this.isLoading = false
      }, failure => {
        eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
      })
    },
    addUserToTag (user) {
      const tags = [this.activeTag]
      const userIds = [user.id]
      this.isLoading = true
      docendo.schoolTagsBulkCreate(this.schoolId, tags, userIds, success => {
        console.log('success', success)
        this.isSubmitted(this.activeTag)
        this.isLoading = false
      }, failure => {
        eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
      })
    }
  },
  mounted () {
    this.getTags()
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-grid-table {
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 7%);
  background: #fff;
  min-height: 80vh;
}

.d-grid-table__column {
  border: 1px solid #d8d8d8;
  flex: 1;
}

.d-grid-table__column ul {
  margin: 0;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}

.d-grid-table__column.d-grid-table__column-1 ul li {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform .25s;
  border: 1px solid transparent;
}

.d-grid-table__column.d-grid-table__column-1 ul li:hover {
  background-color: #eeeeee;
}

.d-grid-table__column.d-grid-table__column-1 ul li.isDragEnter {
  background-color: #f6f9fc;
  border: 1px solid var(--primary);
}

.d-grid-table__column.d-grid-table__column-1 ul li.tags-li-headline {
  border: 1px solid #d8d8d8;
  border-width: 1px 0;
  background: #f6f9fc;
  cursor: default;
  padding: 0.25rem 1rem;
}

.users-list-header
.d-grid-table__column.d-grid-table__column-1 ul li:hover {
  background-color: #f6f9fc;
}

.d-grid-table__column.d-grid-table__column-1 ul li.filter--active {
  background: #f0f8ff;
}

.d-grid-table__column-1 {
  border: 1px solid #d8d8d8;
  border-width: 1px 0 1px 1px;
  flex: 1;
}

.d-grid-table__column-3 {
  flex: 3;
  border-width: 1px;
}

.d-grid-table__column-3 ul li {
  border-bottom: 1px solid #e3e8ee;
  display: flex;
  align-items: center;
}

.d-grid-table__column-3 ul li.isSelected {
  background-color: aliceblue;
}

.d-grid-table__column-3 ul li:hover:not(.users-list-header) {
  box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0, 0 1px 2px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%);
  z-index: 2;
  cursor: move;
}

.d-grid-table__column-3 ul li.users-list-header {
  padding: 0.5rem 1rem;
}

.d-grid-table__column-3 ul li.users-list-header > .text-link {
  cursor: pointer;
}

.d-grid-table__column-header {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  height: 55px;
  font-size: 1rem;
  font-weight: bold;
}

.tags-li__left {
  display: flex;
  align-items: center;
  margin-left: -1rem;
}

.tags-li__create:hover {
  background: initial !important;
}

.tags-li__create > button {
  width: 100%;
  text-align: left;
  transition: transform 0.25s;
}

.tags-li__create > button:hover {
  background: aliceblue;
}

.tags-li__create > button:active {
  transform: scale(0.95);
}

.d-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.submit-button {
  width: 100px;
}

.submit-button.submit-button--danger {
  background: var(--danger) !important;
  border: 1px solid var(--danger) !important;
}

.icon__bg-circle > .d-checkbox {
  margin-left: 0;
  border-color: #222222;
}

.icon__bg-circle > .d-checkbox:before,
.icon__bg-circle > .d-checkbox:after {
  background: transparent;
}

li.isSelected .icon__bg-circle > .d-checkbox:before,
li.isSelected .icon__bg-circle > .d-checkbox:after {
  background: #222222;
}

.d-custom-drag {
  cursor: pointer !important;
  position: absolute;
  top: -1000px;
  background-color: var(--primary);
  width: 200px;
  height: 50px;
  font-size: 1rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 1rem 2rem;
  color: #ffffff;
  font-weight: bold;
  text-transform: uppercase;
}

.d-custom-drag > span {
  margin-right: 0.5rem;
}

.user-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  position: relative;
  padding: 0.5rem 0.5rem 0.5rem 0;
}

.icon__bg-circle {
  min-width: 30px;
  min-height: 30px;
}

.d-tag {
  display: flex;
  align-items: center;
  padding: 1px 5px;
  border-radius: 4px;
  border: 1px solid #e0e6e8;
  color: #646f79;
  font-size: 12px;
  font-weight: 500;
  transition: background-color .02s;
}

.d-tag__text {
  padding: 0 5px;
}

.d-tag__icon {
  font-size: 11px;
  border: 1px solid transparent;
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
  transition: background-color .25s, color .25s;
}

.d-tag__icon:hover {
  background: #888;
  color: white;
}

.user-in-list__left {
  display: flex;
  align-items: center;
}

.user-in-list__left > svg {
  margin-left: 0.5rem;
  fill: var(--grey)
}

.user-name {
  min-width: 250px;
  max-width: 250px;
  width: 250px;
}

.btn-trans {
  color: #468AD7 !important;
}

.d-grid-table__column-header__right {
  display: flex;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// Tagging.vue?610da710